export default {
  "home": "Haus",
  "not_found": "Nicht gefunden",
  "greeting": "Hallo",
}
